

<template>
  <v-layout row wrap>
    <v-flex lg12 md12 sm12 xs 12>
      <v-toolbar color="primary" dark class="hidden-sm-and-down menu_principal mt-1" :absolute="absolute" :height="70" :fixed="toolbarIsFixed">
         <img v-if="toolbarIsFixed" :src="require('@/assets/rpablanco.png')" alt="Registro Público de la Abogacía" width="55" class="ml-4">
        
        <v-spacer></v-spacer>
        <v-toolbar-items class="menu_principal">
          <v-btn flat :to="menu.ruta" v-for="menu in menus" :key="menu.index">{{menu.titulo}}</v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <img v-if="toolbarIsFixed" :src="require('@/assets/logo-vertical-minjus-2021.jpg')" alt="Ministerio de Justicia y Transparencia Institucional" width="100" class="pr-3 pt-3">
        <div v-if="ambiente==='development'" class="baner-development" :class="{'fixed':toolbarIsFixed}">
          AMBIENTE DE PRUEBA
        </div>
      </v-toolbar>
      <v-toolbar color="primary" dark fixed class="hidden-md-and-up mt-1" :height="75">
        <v-toolbar-items>
          <v-btn icon dark @click="dialog=true" large>
            <v-icon size="30">menu</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-toolbar-items class="pt-2 mr-1">
          <v-avatar :size="50">
            <img :src="require('@/assets/rpablanco.png')" alt="alt" width="50" class="ml-2">
          </v-avatar>
        </v-toolbar-items>
        <v-toolbar-title>
          <h2 class=" font-weight-black">RPA</h2>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="pr-2">
          <v-btn icon dark to="/Busqueda" large >
            <v-icon size="30">search</v-icon>
          </v-btn>

        </v-toolbar-items>
         <img :src="require('@/assets/logo-vertical-minjus-2021.jpg')" alt="alt" width="85" class="pt-2 pr-1">
         <div v-if="ambiente==='development'" class="baner-development fixed">
          AMBIENTE DE PRUEBA
        </div>
      </v-toolbar>
    </v-flex>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>
          <v-toolbar color="primary" dark fixed class="hidden-md-and-up" :height="75">
            <v-toolbar-items>
              <v-btn icon dark @click="dialog=false" large>
                <v-icon size="30">close</v-icon>
              </v-btn>
            </v-toolbar-items>
            <v-toolbar-items class="pt-2 mr-1">
              <v-avatar :size="50">
                <img :src="require('@/assets/rpablanco.png')" alt="alt" width="55" class="ml-2">
              </v-avatar>
            </v-toolbar-items>
            <v-toolbar-title>
              <h2 class=" font-weight-black">RPA</h2>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="pr-2">
              <v-btn icon dark to="/Busqueda" large >
                <v-icon size="35">search</v-icon>
              </v-btn>

            </v-toolbar-items>
            <img :src="require('@/assets/logo-vertical-minjus-2021.jpg')" alt="alt" width="85" class="pt-2 pr-1">
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pt-5">
          <v-list  dense two-line class="lista_menu ma-2">
            <v-list-tile
              ripple
              :to="menu.ruta"
              @click="dialog=false"
              v-for="menu in menus"
              :key="menu.index"
              active-class="menu_active"
            >
              <span class="font-weight-black">{{menu.titulo}}</span>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      titulo: "Registro Público de la Abogacia",
      absolute: false,
      menus: [
        {
          titulo: "INICIO",
          ruta: "/inicio"
        },
        {
          titulo: "BÚSQUEDA",
          ruta: "/busqueda"
        },
        {
          titulo: "NORMATIVA",
          ruta: "/normativa"
        },
        {
          titulo: "BUZÓN DIGITAL",
          ruta: "/buzon-digital"
        },
        {
          titulo: "REGISTRO",
          ruta: "/registro"
        },
        {
          titulo: "RENOVACIÓN Y/O REPOSICIÓN",
          ruta: "/credenciales"
        },
        {
          titulo: "CERTIFICACIÓN",
          ruta: "/certificacion"
        },
        {
          titulo: "DENUNCIAS",
          ruta: "/denuncia"
        },
        {
          titulo: "JURAMENTO",
          ruta: "/juramento"
        },
        {
          titulo: "CAPACITACIÓN",
          ruta: "/Capacitacion"
        }
      ],
      ambiente:process.env.AMBIENTE
    };
  },
  computed:{
    toolbarIsFixed(){
      return this.$store.state.menu_fixed;
    }
  }
};
</script>
<style>
.menu_active {
  background: #4a576d !important;
  color: aliceblue !important;
}
.menu_principal .v-toolbar__content{
  padding: 0 0 !important;
}
.menu_principal .v-btn--active{
  color: aliceblue !important;
  background: #687086 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/Menu.vue